// @ts-ignore
import * as enquire from 'enquire.js';

export namespace Tabs {
    let mobileMenuInit = () => {
        // Turn our tabs into a menu at mobile
        enquire.register('screen and (max-width:767px)', {
            match: function () {
                $('.tab-list')
                    .not('.tab-list--module')
                    .each(function () {
                        var $tabParent = $(this);
                        var $tabList = $tabParent.find('.js-tabs');
                        var $activeItem = $tabParent.find(
                            '.js-tab.state-selected'
                        );
                        var activeItemText = $activeItem.text();

                        if ($tabList.length > 1) {
                            $tabList.slice(1).remove();
                        }

                        $(
                            `<a href="#" class="js-tabs-mobile-trigger tab-list__mobile-trigger">${activeItemText}</a>`
                        )
                            .insertBefore($tabList)
                            .wrap(
                                "<div class='tab-list__mobile-wrap js-tabs-mobile-wrapper'/>"
                            );

                        $tabList.appendTo(
                            $tabParent.find('.js-tabs-mobile-wrapper')
                        );
                    });

                //setup click events on mobile menu
                registerMobileClickEvents();
            },
            unmatch: function () {
                // Cleanup mobile wrapper / trigger elements
                $('.js-tabs-mobile-wrapper').each(function () {
                    $(this).contents().unwrap();
                    $(this).remove();
                });

                $('.tab-list').each(function () {
                    let $tabList = $(this).find('.js-tabs');

                    if ($tabList.length > 1) {
                        $tabList.slice(1).remove();
                    }
                });

                $('.js-tabs-mobile-trigger').remove();

                removeMobileClickEvents();
            },
        });

        $('.js-tab').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var target = $this.data('target');
            var $tabList = $this.closest('.tab-list');
            var $contents = $tabList.find('.js-tab-contents').children();
            var $tabs = $tabList.find('.js-tab');

            $tabs.removeClass('state-selected');
            $this.addClass('state-selected');

            // Trigger a tab change event
            $(this).trigger('tabChange', {
                tab: this,
                target: $this.data('target') || null,
            });

            // If there's no data-target for this tab, we're done
            if (!target) {
                return;
            }

            $contents.removeClass('state-active');
            var $selectedTab = $contents.filter(target);

            if ($selectedTab.length) {
                $selectedTab.addClass('state-active');
            }
        });

        let params = new URLSearchParams(window.location.href);
        let capitalizedQueryParam;

        if (params.get('FilterCriteria.Tab')) {
            capitalizedQueryParam =
                params.get('FilterCriteria.Tab').charAt(0).toUpperCase() +
                params.get('FilterCriteria.Tab').slice(1);
        }

        $('.js-tabs').each(function () {
            let $this = $(this);
            $this.find('.js-tab').each(function () {
                let $jsTab = $(this);
                if (capitalizedQueryParam) {
                    if ($jsTab.text() === capitalizedQueryParam) {
                        $jsTab.trigger('click');
                        $('.js-tabs-mobile-trigger').text($jsTab.text());
                    }
                } else if (!$this.find('.js-tab').hasClass('state-selected')) {
                    $this.find('.js-tab:first-child').trigger('click');
                    $('.js-tabs-mobile-trigger').text(
                        $this.find('.js-tab:first').text()
                    );
                }
            });

            $this.removeClass('state-visible');
        });
    };

    let registerMobileClickEvents = () => {
        $('body').on(
            'click.mobileTabs',
            '.js-tabs-mobile-trigger',
            function (e) {
                var $parent = $(this).closest('.tab-list__mobile-wrap');
                $parent.find('.js-tabs').toggleClass('state-visible');
                $parent.toggleClass('state-open');
                e.preventDefault();
            }
        );

        $('body').on('click.mobileTabs', '.js-tab', function () {
            var $this = $(this);
            var $parent = $this.closest('.js-tabs-mobile-wrapper');
            $parent.find('.js-tabs').toggleClass('state-visible');

            $parent.find('.js-tabs-mobile-trigger').text($this.text());
        });
    };

    let removeMobileClickEvents = () => {
        $('body').off('click.mobileTabs').off('click.mobileTabs');
    };

    //this is the layout widget version
    let setupTabsModule = () => {
        let tabModules = document.querySelectorAll('.js-tab-module-parent');
        let params = new URL(document.location.href).searchParams;
       
        if (!tabModules.length) {
            return;
        }

        tabModules.forEach((module) => {
            let tabs = module.querySelectorAll('.js-tab-module');
            let contentDivs = module.querySelectorAll('.js-tab-module-content');
            let mobileTrigger = module.querySelector(
                '.js-tab-module-mobile-trigger'
            );
            let tabsUl = module.querySelector('.js-tab-module-tabs');

            mobileTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                if (tabsUl.classList.contains('state-visible')) {
                    mobileTrigger.classList.remove('state-open');
                    tabsUl.classList.remove('state-visible');
                } else {
                    tabsUl.classList.add('state-visible');
                    mobileTrigger.classList.add('state-open');
                }
            });

            tabs.forEach((tab, index) => {
                //create Ids that match up with tabs
                contentDivs[index].setAttribute(
                    'id',
                    tab.getAttribute('data-target')
                );

                //set first tab as selected
                if (index === 0) {
                    tab.classList.add('state-selected');
                    contentDivs[index].classList.add('state-active');
                    mobileTrigger.textContent = tab.textContent;
                }

                //setup click handler on all the tabs
                tab.addEventListener('click', (e) => {
                    e.preventDefault();
                    let theTarget = tab.getAttribute('data-target');
                    let divToShow = document.getElementById(theTarget);
                    //remove other tabs selected state and make current tab active
                    tabs.forEach((tab, index) => {
                        tab.classList.remove('state-selected');
                    });
                    tab.classList.add('state-selected');
                    mobileTrigger.textContent = tab.textContent;
                    tabsUl.classList.remove('state-visible');
                    mobileTrigger.classList.remove('state-open');
                    //remove selected content state-active class and add to current one
                    contentDivs.forEach((contentDiv) => {
                        contentDiv.classList.remove('state-active');
                    });
                    divToShow.classList.add('state-active');
                });
            });
        });

        if (params.has('tab')) {
            let tabID = params.get('tab');
            let clickEvent = new Event('click');
            let targetTab = document.querySelector(
                `.js-tab-module[data-target="${tabID}"]`
            );

            if (targetTab) {
                targetTab.dispatchEvent(clickEvent);
            }
        }
    };

    /**
     * Class Method for Rendering Breadcrumbs
     */
    export const init = () => {
        mobileMenuInit();
        setupTabsModule();
    };
}
